(() => {
  if (window.castlewoodClearCart) return;
  window.castlewoodClearCart = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cw-clear-cart]');
    if (!button || button.disabled) return;
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';

    try {
      const response = await fetch(button.dataset.clearUrl, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error('Cart clear failed');
      const cart = await response.json();
      if (cart.item_count !== 0 || !Array.isArray(cart.items) || cart.items.length) {
        throw new Error('Cart was not cleared');
      }
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (status) status.textContent = button.dataset.errorMessage;
    }
  });
})();
